import {
  Box,
  Container,
  Text,
  VStack,
  HStack,
  Heading,
  Link,
  // eslint-disable-next-line no-restricted-imports
  Button as ChakraButton,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useContactModal } from 'src/hooks/useContactModal';
import { ContactModal } from 'src/components/molecules/ContactModal';
import { ResourcePageStep } from '../../../molecules/ResourcePageStep';
import { WORKSPACE_SETTINGS_SECTIONS } from '../../../../utils/constants';
import type { ResourcePageStepData } from '../../../molecules/ResourcePageStep';

const WorkspaceSettingsPage: React.FC = () => {
  const { onOpen, modalProps } = useContactModal({
    defaultInterest: 'support',
    title: 'Contact Support',
    submitButtonText: 'Contact',
  });

  return (
    <>
      <Box bg="white" color="text.darkBlue.900" fontFamily="marketingPage">
        <Container maxW="container.xl" pt={{ base: 8, md: 16 }}>
          {/* Breadcrumb */}
          <HStack
            spacing={4}
            mb={4}
            fontSize="16px"
            color="text.darkBlue.800"
            fontWeight="500">
            <Link
              as={RouterLink}
              to="/resources"
              opacity="0.6"
              _hover={{ opacity: 1, textDecoration: 'underline' }}
              cursor="pointer">
              Resources & Docs
            </Link>
            <Text>/</Text>
            <Text>Workspace Settings</Text>
          </HStack>

          {/* Header */}
          <VStack align="start" spacing={4} mb={{ base: 12, md: 24 }}>
            <Text fontSize={{ base: '24px', md: '40px' }} fontWeight="700">
              WORKSPACE SETTINGS
            </Text>
            <Text
              fontSize="15px"
              color="text.darkBlue.800"
              fontFamily="marketingPage"
              fontWeight="normal">
              Manage the key settings that keep your workspace accurate, secure,
              and aligned.
            </Text>
          </VStack>

          {/* Settings Sections */}
          <VStack spacing={0} align="stretch" mb={32}>
            {WORKSPACE_SETTINGS_SECTIONS.map(
              (section: ResourcePageStepData, index: number) => (
                <ResourcePageStep
                  key={section.number}
                  step={section}
                  isLast={index === WORKSPACE_SETTINGS_SECTIONS.length - 1}
                  showNumber={false}
                />
              ),
            )}
          </VStack>

          {/* Custom Requirements Section */}
          <Box bg="white" borderRadius="2xl" p={8} mb={16} textAlign="center">
            <VStack spacing={6}>
              <Heading
                color="text.darkBlue.900"
                fontSize={{ base: '2xl', md: '3xl', lg: '56px' }}
                fontFamily="marketingPage"
                fontWeight="700">
                Need Something Custom?
              </Heading>
              <Text
                fontSize={{ base: 'lg', md: '21px' }}
                color="text.darkBlue.800"
                fontWeight="500"
                maxW="1176px">
                Options like single sign-on (SSO), custom integrations, or
                special security requirements aren&apos;t available for
                self-service setup. Contact support and our team will tailor the
                workspace to your company&apos;s needs.
              </Text>
              <ChakraButton
                onClick={onOpen}
                size="lg"
                bg="icon.green"
                color="white"
                fontWeight="bold"
                fontFamily="marketingPage"
                borderRadius="8px"
                px={8}
                _hover={{ bg: 'icon.green.500' }}>
                Contact
              </ChakraButton>
            </VStack>
          </Box>
        </Container>
      </Box>
      <ContactModal {...modalProps} />
    </>
  );
};

export default WorkspaceSettingsPage;
